// extracted by mini-css-extract-plugin
export default {"caption":"Figure_caption__nh2g1"};